import { useParams } from "react-router-dom";
import { useSprintQuery } from "sprint-common-web";

import { useAssetsApi } from "../../../../../common/api/master-api/assets/useAssetsApi";
import { CloudAssetDetails, mapToCloudAssetDetails } from "../../CloudAssetDetails";
import { CloudAssetQueryKey } from "../CloudAssetQueryKey";

export const useCloudAssetDetails = () => {
    const { assetId } = useParams<{ assetId: string }>();
    const { getCloudAssetDetails } = useAssetsApi();

    return useSprintQuery<CloudAssetDetails>({
        queryKey: [CloudAssetQueryKey.CloudAssetDetails, assetId],
        queryFn: async (): Promise<CloudAssetDetails> => {
            const response = await getCloudAssetDetails({ assetId });

            return mapToCloudAssetDetails(response);
        }
    });
};
